import { createFileRoute } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { PoliciesPage } from "@/pages/dashboard/policies/page";

export const Route = createFileRoute("/_main/dashboard/policies/")({
  component: () => (
    <RequirePermission action="policies.read">
      <PoliciesPage />
    </RequirePermission>
  ),
});
